var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTableIconActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 32,
    viewBox: "0 0 41 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0481 32H0.0552979V0H40.0481V32ZM3.16258 28.8252H36.9408V3.17483H3.16258V28.8252Z",
    fill: "#C53036"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.385 8.53381H6.13464V11.7086H12.385V8.53381Z",
    fill: "#C53036"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9721 8.53381H16.7217V11.7086H22.9721V8.53381Z",
    fill: "#C53036"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5631 8.53381H27.3127V11.7086H33.5631V8.53381Z",
    fill: "#C53036"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.385 15.3911H6.13464V18.5659H12.385V15.3911Z",
    fill: "#C53036"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9721 15.3911H16.7217V18.5659H22.9721V15.3911Z",
    fill: "#C53036"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5631 15.3911H27.3127V18.5659H33.5631V15.3911Z",
    fill: "#C53036"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.385 22.2482H6.13464V25.423H12.385V22.2482Z",
    fill: "#C53036"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9721 22.2482H16.7217V25.423H22.9721V22.2482Z",
    fill: "#C53036"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5631 22.2482H27.3127V25.423H33.5631V22.2482Z",
    fill: "#C53036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableIconActive);
export default __webpack_public_path__ + "static/media/table-icon-active.a17ae7506f0b3399a0c0dade5336e424.svg";
export { ForwardRef as ReactComponent };